// extracted by mini-css-extract-plugin
export default {"servicesListWrapper":"ServicesList_servicesListWrapper__Vy+8H","servicesCard":"ServicesList_servicesCard__8sn-S","a":"ServicesList_a__YKDNw"};